export default "__VITE_ASSET__CC6nVEU2__"